export default __webpack_public_path__ + "static/media/customer2.03318a95.png";